import React, { useState } from "react";
import {
    AuditorAccessManager,
    AuditorSoc1Intake
} from "icfrontendui/comp/product";

import "../../styles/dashboard.css"

const Dashboard = () => {
    const [ activeShare, setActiveShare ] = useState({})

    const handleRowSelect = (share) => {
        if (activeShare.account_key !== share.account_key) {
            setActiveShare(share);
        } else setActiveShare({});
    }

    return (
        <div className="main-dashboard-container">
            <AuditorAccessManager
                activeShare={activeShare}
                handleRowSelect={row => handleRowSelect(row)}
            />
            {activeShare.name ? (
                <AuditorSoc1Intake activeShare={activeShare} />
            ) : null}
        </div>
    )
}

export default Dashboard;
